import React, { FC, useState } from 'react';
import { Tooltip, Value } from '@investoro/core';
import clsx from 'clsx';
import styled from 'styled-components';

import Icon, { IconEnum } from 'components/common/Icon';
import { Variant } from 'components/functions/offerListFunctions/saleOfferListFunctions/saleOfferListFunctions';

const ValueBox = styled(Value)<{ variant?: Variant; isHovered: boolean; minWidth?: number; }>`
    display: flex;
    gap: 6px;
    padding: 2px 6px;
    border-radius: 6px;
    cursor: pointer;
    font-style: italic;
    min-width: ${({ minWidth, variant }) => variant === Variant.DIFFERENT && minWidth ? `${minWidth}px` : 'auto'};
    
    img {
        width: 20px;
        height: 20px;
    }

    .blurred {
        filter: blur(3px);
        transition: filter 0.1s ease;
    }

    ${({ variant }) => variant === Variant.DIFFERENT &&
        `
        background-color: var(--label-color-light);

        &:hover {
            background-color: var(--background-color-ai);
        }
    `}

    ${({ variant }) => variant === Variant.PREDICTED &&
        `
        background-color: var(--background-color-ai);
    `}
`;

export interface DetailValueElementProperties {
    variant?: Variant;
    minWidth?: number;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    onClick?: () => void;
    showTooltip?: boolean;
    prefix?: string;
    suffix?: string;
    value: string | number;
    tooltipText?: string;
    isBlurred?: boolean;
}

const DetailValueElement: FC<DetailValueElementProperties> = ({
    tooltipText,
    onMouseEnter,
    onMouseLeave,
    onClick,
    showTooltip,
    variant = Variant.DEFAULT,
    minWidth,
    value,
    prefix,
    suffix,
    isBlurred
}) => {
    const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null);

    if (variant === Variant.DEFAULT) {
        return <Value dangerouslySetInnerHTML={{ __html: value as string }} />;
    }

    return (
        <>
            <ValueBox
                ref={setReferenceElement}
                variant={variant}
                isHovered={!!showTooltip}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={onClick}s
                minWidth={minWidth}
            >
                {prefix && prefix}
                <span className={clsx(isBlurred && 'blurred')}>{value}</span>
                {suffix && suffix}
                {<Icon icon={IconEnum.AI_STARS} />}
            </ValueBox>
            {tooltipText && showTooltip && <Tooltip text={tooltipText} referenceElement={referenceElement} showTooltip={showTooltip} />}
        </>
    );
};

export default DetailValueElement;
